export const resolveAssistantBookingAvailability = (assistant = {}) => {
  if (typeof assistant.isOnline === "boolean") return assistant.isOnline;
  if (typeof assistant.isAvailable === "boolean") return assistant.isAvailable;
  return null;
};
